<template>
  <div
    class="note tw-box-border tw-relative tw-my-2 tw-p-1 tw-text-sm tw-text-left tw-flex tw-px-2 tw-rounded-md tw-bg-green-100 tw-items-center"
  >
    <div class="">
      <p>{{ note.Text }}</p>
      <p class="tw-text-xs tw-text-slate-500">
        {{ note.CreatedAt | formatedDate }}
      </p>
    </div>
    <button
      v-if="removable"
      class="tw-absolute tw-w-2 tw-h-2 tw-m-auto tw-top-1 tw-right-1 tw-rounded-full"
      @click="onRemove"
    >
      <svg
        class="tw-fill-slate-400 hover:tw-fill-slate-900"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 320 512"
      >
        <!--! Font Awesome Pro 6.1.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2022 Fonticons, Inc. -->
        <path
          d="M310.6 361.4c12.5 12.5 12.5 32.75 0 45.25C304.4 412.9 296.2 416 288 416s-16.38-3.125-22.62-9.375L160 301.3L54.63 406.6C48.38 412.9 40.19 416 32 416S15.63 412.9 9.375 406.6c-12.5-12.5-12.5-32.75 0-45.25l105.4-105.4L9.375 150.6c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0L160 210.8l105.4-105.4c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25l-105.4 105.4L310.6 361.4z"
        />
      </svg>
    </button>
  </div>
</template>

<script>
import dayjs from "dayjs";
import localizedFormat from "dayjs/plugin/localizedFormat";

dayjs.extend(localizedFormat);

export default {
  name: "RemovableNote",
  props: {
    note: Object,
    removable: Boolean,
  },
  filters: {
    formatedDate(value) {
      return dayjs(value).format("llll");
    },
  },
  methods: {
    async onRemove() {
      try {
        this.$store.dispatch("chat/removeNote", this.note);
        this.$emit("remove-note", this.note.ID);
      } catch (error) {
        console.error(error);
      }
    },
  },
};
</script>

<style>

</style>
